import type { Envelope } from './types';
import { uuidv4 } from './utils/uuid';

export const PROTOCOL_VERSION = '1';

/** Build a protocol envelope message. */
export function buildEnvelope(
  type: string,
  payload: Record<string, unknown>,
  context: { sessionId: string; viewerType: string; schemaVersion: string },
): Envelope {
  return {
    protocolVersion: PROTOCOL_VERSION,
    type,
    requestId: uuidv4(),
    sessionId: context.sessionId,
    viewerType: context.viewerType,
    schemaVersion: context.schemaVersion,
    payload,
  };
}

/** Check whether a raw postMessage payload is a valid envelope. */
export function isEnvelope(data: unknown): data is Envelope {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  return d.protocolVersion === PROTOCOL_VERSION && typeof d.type === 'string';
}
